/* eslint-disable */
export default {
  save: 'Opslaan',
} as const;

// @key: @#@"save"@#@ @source: @#@"Save"@#@
